module.exports = __webpack_public_path__ + "static/media/nav-icon-hiring-inactive.c2e47874.svg";